module.exports = __webpack_public_path__ + "3872a63e91fc3dc5fc3e7f0dc14e35cb.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/158.png
// module id = 1753
// module chunks = 2